"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addNewCard = addNewCard;
exports.createPaymentForAddCard = createPaymentForAddCard;
exports.deleteSavedCardV2 = deleteSavedCardV2;
exports.getCardStatus = getCardStatus;
exports.getPaymentCards = getPaymentCards;
exports.getSavedCardsV2 = getSavedCardsV2;
exports.markSavedCardAsDefaultV2 = markSavedCardAsDefaultV2;
exports.removePaymentCard = removePaymentCard;
exports.saveNewCard = saveNewCard;
exports.saveNewCardV2 = saveNewCardV2;
exports.setDefaultCard = setDefaultCard;
var _genericFetch = _interopRequireWildcard(require("../../../common/api/genericFetch"));
var _ApiConst = require("../../../common/utils/ApiConst");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import { apiCall } from '../../../common/api/api';

function getPaymentCards(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_PAYMENT_LIST}/${requestParams}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getSavedCardsV2(requestParams, tokenData) {
  const {
    userId,
    cardId
  } = requestParams;
  let queryString = `?userId=${userId}`;
  if (cardId) {
    queryString += `&cardId=${cardId}`;
  }
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.CARDS_V2}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function createPaymentForAddCard(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.CREATE_PAYMENT_TO_ADD_CARD}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.POST, apiPostData: requestParams });
}
function setDefaultCard(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.SET_DEFAULT_CARD_URL}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.PUT;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.PUT, apiPostData: requestParams });
}
function deleteSavedCardV2(requestParams, tokenData) {
  const {
    userId,
    cardId
  } = requestParams;
  let queryString = `/${userId}`;
  if (cardId) {
    queryString += `/${cardId}`;
  }
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.CARDS_V2}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.DELETE;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.PUT, apiPostData: requestParams });
}
function markSavedCardAsDefaultV2(requestParams, tokenData) {
  const {
    userId,
    cardId,
    markDefault
  } = requestParams;
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.CARDS_V2}/${userId}/${cardId}/markDefault?markDefault=${markDefault}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.PUT;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.PUT, apiPostData: requestParams });
}
function removePaymentCard(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.REMOVE_CARD_URL}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.DELETE;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, requestType: API_PARAMS.DELETE, apiPostData: requestParams });
}
function addNewCard(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.ADD_NEW_CARD_URL}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.POST, apiPostData: requestParams });
}
function saveNewCardV2(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.CARDS_V2}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.POST, apiPostData: body });
}
function saveNewCard(requestParams, tokenData) {
  const {
    refID,
    params,
    body
  } = requestParams;
  let queryString = '?';
  for (const key in params) {
    if (queryString === '?') {
      queryString = queryString + key + '=' + params[key];
    } else {
      queryString = queryString + '&' + key + '=' + params[key];
    }
  }
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.SAVE_NEW_CARD_URL}/${refID}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = body;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.POST, apiPostData: body });
}
function getCardStatus(requestParams, tokenData) {
  // eslint-disable-next-line camelcase
  const {
    order_ref_id,
    params
  } = requestParams;
  let queryString = '?';
  for (const key in params) {
    if (queryString === '?') {
      queryString = queryString + key + '=' + params[key];
    } else {
      queryString = queryString + '&' + key + '=' + params[key];
    }
  }
  // eslint-disable-next-line camelcase
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_CARD_STATUS_URL}/${order_ref_id}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}